(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Initialize AjaxProduct for all product grid forms in this section
    var sectionId = 'CollectionSection-{{ section.id }}';
    var section = document.getElementById(sectionId);
    
    if (section && typeof theme !== 'undefined' && theme.AjaxProduct) {
      var initForms = function() {
        var forms = section.querySelectorAll('.product-grid-item__form');
        forms.forEach(function(form) {
          // Only initialize if not already initialized
          if (!form.dataset.ajaxInitialized) {
            var ajaxProduct = new theme.AjaxProduct(form);
            
            // Override the success method to prevent redirect and open cart drawer
            var originalSuccess = ajaxProduct.success;
            ajaxProduct.success = function(product) {
              // Temporarily change cartType to prevent redirect
              var savedCartType = theme.settings.cartType;
              theme.settings.cartType = 'drawer';
              
              // Call original success method with correct context
              originalSuccess.call(this, product);
              
              // Restore cartType
              theme.settings.cartType = savedCartType;
              
              // Ensure cart drawer opens and updates
              setTimeout(function() {
                // Dispatch ajaxProduct:added event on document for CartDrawer to catch
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                  detail: {
                    product: product,
                    addToCartBtn: ajaxProduct.addToCart
                  },
                  bubbles: true
                }));
                
                // Also dispatch cart:open to ensure drawer opens
                document.dispatchEvent(new CustomEvent('cart:open'));
              }, 150);
            };
            
            form.dataset.ajaxInitialized = 'true';
          }
        });
      };
      
      // Initialize on page load
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initForms);
      } else {
        initForms();
      }
      
      // Re-initialize when section is loaded/reloaded (for theme editor)
      if (typeof theme !== 'undefined' && theme.sections) {
        theme.sections.onLoad(sectionId, initForms);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
